var map = {
	"./_browser/_browser.js": 9,
	"./animate/animate.js": 10,
	"./aside/aside.js": 11,
	"./carousel/carousel.js": 12,
	"./common.js": 4,
	"./conveyor/conveyor.js": 13,
	"./footer/footer.js": 14,
	"./header-nav/header-nav.js": 15,
	"./indicators/indicators.js": 16,
	"./navigation/navigation.js": 17,
	"./registrator/registrator.js": 18,
	"./slider/slider.js": 19,
	"./svg-sprite-load/svg-sprite-load.js": 20,
	"./tabs/tabs.js": 21,
	"./teaser/teaser.js": 22
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8;


//////////////////
// WEBPACK FOOTER
// ./common.blocks \.js$
// module id = 8
// module chunks = 1